<!--
    file type .....: HTML file: medfamlookup.component.html
    Created By ....: ianday
    Date ..........: 4/27/25 
-->
<div class="medfamlookup-container">

    <div class="query-strip-container mat-elevation-z2">
        <table style="height:100%; width:100%;">
            <TR>
                <TD align="center" style="min-width: 50%;text-align:right;">Filter:
                    <input text id="txtFilterId" #txtFilter
                           [(ngModel)]="valFilter"
                           class="qs_filter-field"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="valFilter=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                    <button mat-button class="command-button" style="width: 95px;" (click)="addNewHandler()" matTooltip="Add new medication family" mat-button>
						<mat-icon>add_circle_outline</mat-icon>
						New
					</button>
                </TD>

                <TD class="table-pagination-cell" style="width: 30%;text-align:right;">{{pagination}} Record(s) ...</TD>
            </TR>
        </table>
    </div>

    <div class="table-container mat-elevation-z1"
         (keydown)="tableKeyDown($event)" tabindex="-1">
        <table mat-table [dataSource]="dataSource" matSort
               (matSortChange)="onSortChange($event)">

            <!-- Position Column -->
            <ng-container matColumnDef="itemPrefix">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="mat-table-header-style" style="width:12%">Prefix</th>
                <td mat-cell class="mat-table-row-style" style="width:12% !important;"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{element.itemPrefix}}</td>
            </ng-container>

            <ng-container matColumnDef="description" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="mat-table-header-style" style="width:80%">Description</th>
                <td mat-cell class="mat-table-row-style" style="width:80% !important;"
                    *matCellDef="let element">{{element.description}}</td>
            </ng-container>

            <ng-container matColumnDef="schedule">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="mat-table-header-style" style="width: 3%">Schedule</th>
                <td mat-cell class="mat-table-row-style" style="width: 3%; text-align: center;"
                    *matCellDef="let element">{{element.schedule}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row, tableRowIdx)" (dblclick)="onDoubleClickRow(row, tableRowIdx)">
            </tr>
        </table>
        <app-dw-spinner [visible]="busyCursor"> </app-dw-spinner>
        <div [hidden]="hideNoRecs" class="no-recs-found">Working ...</div>
    </div>

    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div class="save-close-strip" style="bottom: 3px;">

        <button mat-button class="command-button" [disabled]="(Idx < 0)"
                (click)="submitRecord()" matTooltip="Submit the selected record"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Submit
        </button>
        <button mat-button class="command-button"
                (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>


</div>

<p-dialog header="Quick Add - Medication Family" [focusOnShow]="false"
          [(visible)]="displayQuickAddMedFamilyDlg" [modal]="true"
          [style]="{width: '700px', height: '400px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-quickadd-medfamily #quickAddMedFamily
        (cancelClicked)="displayQuickAddMedFamilyDlg=false"
        (submitClicked)="quickMedFamilyAddedHandler($event)">
    </app-quickadd-medfamily>
</p-dialog>